import { render, staticRenderFns } from "./pictureDragDrop.vue?vue&type=template&id=f04463c4&scoped=true"
import script from "./pictureDragDrop.vue?vue&type=script&lang=js"
export * from "./pictureDragDrop.vue?vue&type=script&lang=js"
import style0 from "./pictureDragDrop.vue?vue&type=style&index=0&id=f04463c4&prod&scoped=true&lang=scss"
import style1 from "./pictureDragDrop.vue?vue&type=style&index=1&id=f04463c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f04463c4",
  null
  
)

export default component.exports